import { assertNever } from '@eversports/utility-types'
import React from 'react'

import { PaymentOption } from '../../typings/Payment'

import additionalPaymentMethodImg from './img/additional-payment-methods.svg'
import creditCardImg from './img/credit-card.svg'

interface Props {
  paymentOption: PaymentOption
}

const PaymentMethodExpansionPanelHeaderIcon: React.FC<React.PropsWithChildren<Props>> = ({ paymentOption }) => {
  switch (paymentOption) {
    case 'pay-with-credit-card':
      return <img src={creditCardImg} width="32" />
    case 'additional-payment-methods':
    case 'pay-with-ideal':
    case 'pay-with-sepa-ideal':
      return <img src={additionalPaymentMethodImg} width="32" />
    default:
      return assertNever(paymentOption)
  }
}

export default PaymentMethodExpansionPanelHeaderIcon
